<ng-container>
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">Ordinamento</span>

        <button
            mat-icon-button
            type="button"
            aria-label="Chiudi"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content">
        <mat-radio-group [formControl]="sortControl" class="radio-group">
            <mat-radio-button value="ragioneSociale_asc">Ragione Sociale A → Z</mat-radio-button>
            <mat-radio-button value="ragioneSociale_desc">Ragione Sociale Z → A</mat-radio-button>
        </mat-radio-group>
    </mat-dialog-content>

    <mat-dialog-actions class="buttons-container">
        <button matButton (click)="onReset()">Cancella</button>
        <button matButton="filled" (click)="onApply()">Applica</button>
    </mat-dialog-actions>
</ng-container>
